import { render, staticRenderFns } from "./MoleculeContactPoint.vue?vue&type=template&id=38775dc6&scoped=true&"
import script from "./MoleculeContactPoint.vue?vue&type=script&lang=js&"
export * from "./MoleculeContactPoint.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContactPoint.vue?vue&type=style&index=0&id=38775dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38775dc6",
  null
  
)

export default component.exports